export const mainMenuNiveauFinalProps = () => ({
  navigationNode: {
    type: Object,
    required: false,
    default() {
      return {};
    }
  },
  showImage: {
    type: Boolean,
    required: false,
    default: false
  },
  isGroup: {
    type: Boolean,
    required: false,
    default: false
  },
  isLast: {
    type: Boolean,
    required: false,
    default: false
  },
  prevCategoryLabel: {
    type: String,
    required: false,
    default: ""
  },
  coinDesMarquesIds: {
    type: Array,
    required: false,
    default: () => []
  },
  arborescence: {
    type: Array,
    required: false,
    default: () => []
  }
})


export const useMainMenuNiveauFinal = (props, currentItem) => {
  const showMerch = computed(() => {
    return (currentItem.value === null || !currentItem.value.attributes.children) && props.navigationNode.attributes.push_zones && props.navigationNode.attributes.push_zones.length > 0
  })
  const isCoinDesMarques = computed(() => {
    return props.coinDesMarquesIds.find(item => props.navigationNode.id === item)
  })

  return { showMerch, isCoinDesMarques }
}